module.exports = __webpack_public_path__ + "img/charlie-tmb.7b5683f8.png";